<template>
	<button type="button" id="more-button" @click="onClick"><IconEllipsisH />&nbsp;</button>
</template>

<script>
	import IconEllipsisH from "@/components/icons/IconEllipsisH"
	import { mapState } from "vuex";

	export default {
		components: {
			IconEllipsisH
		},
		computed: {
			...mapState([ "currentSong", "mainbarExtended" ])
		},
		methods: {
			onClick() {
				this.$store.commit("setMainbarExtended", !this.mainbarExtended);
			}
		}

	}

</script>

<style lang="scss" scoped>
	button {
		width: 48px;
		position: fixed;
		top: 0;
		top: calc(constant(safe-area-inset-top) + 0px);
		top: calc(env(safe-area-inset-top) + 0px);
		right: 75px;

		.icon-ellipsis-h {
			width: 20px;
			margin: 6px 0 0 -6px;
			position: absolute;
		}
	}
</style>
